<div class="modal-header">
  <h4 class="modal-title">
    <i data-feather="plus"></i> Yeni Firma Ekle
  </h4>
</div>
<div class="modal-body" *blockUI="'section-blocks'">
  <form [formGroup]="companyForm" (ngSubmit)="onSubmit()" class="mt-2">
    <div class="row">
      <div class="form-group col-xl-6 col-md-6 col-sm-12">
        <label class="form-label">Hesap Türü</label>
        <div class="row ml-1">
          <div *ngFor="let type of dvAccountTypes" class="custom-control custom-radio"
            style="margin-right: 5px; display: flex; align-items: center;">
            <input type="radio" id="radio-{{type.value}}" name="DVAccountType" formControlName="DVAccountType"
              class="custom-control-input" [(ngModel)]="selectedAccountType" [value]="type.value"
              (change)="onAccountTypeChange($event)" />
            <label class="custom-control-label" for="radio-{{type.value}}">{{ type.key
              }}</label>
          </div>
        </div>
        <div *ngIf="companyForm.controls['DVAccountType'].invalid && companyForm.controls['DVAccountType'].touched"
          class="text-danger">
          Hesap Türü seçmek zorunludur!
        </div>
      </div>

      <div class="col-6">
        <div class="form-group mb-2">
          <label for="title">Firma Adı</label>
          <input type="text" formControlName="title" class="form-control" placeholder="Firma adı" />
        </div>
      </div>

      <div class="col-md-6 col-12">
        <div class="form-group mb-2">
          <label for="title">İndirim Oranı</label>
          <input type="text" formControlName="discountRate" class="form-control" placeholder="İndirim Oranı" />
        </div>
      </div>

      <div class="col-md-6 col-12">
        <div class="form-group mb-2">
          <label for="title">Vadeli Gün</label>
          <input type="text" formControlName="futureDay" class="form-control" placeholder="İndirim Oranı" />
        </div>
      </div>

      <div class="col-md-6 col-12">
        <div class="form-group mb-2">
          <label for="type">Kategori</label>
          <ng-select [items]="categories" formControlName="categoryId" placeholder="Kategory Seç" bindValue="id"
            bindLabel="categoryName"></ng-select>
        </div>
      </div>

      <div class="col-md-6 col-12">
        <div class="form-group mb-2">
          <label for="responsiblePerson">Para birimi</label>
          <ng-select [items]="currencies" [searchable]="false" formControlName="currencyId" bindLabel="currencyName"
            bindValue="id" placeholder="Para birimi seç"></ng-select>
        </div>
      </div>

      <div class="col-md-4 col-sm-12">
        <label class="form-label" for="categoryId">Ülke</label>
        <select class="form-control" (change)="onCountryChange($event)">
          <option value="" disabled selected>Ülke Seçiniz</option>
          <option *ngFor="let item of countries" [value]="item.id">
            {{item.name}}
          </option>
        </select>
      </div>

      <div class=" col-md-4 col-sm-12">
        <label class="form-label" for="categoryId">İl</label>
        <select class="form-control" (change)="onProvinceChange($event)" formControlName="provinceId">
          <option value="" disabled selected>İl Seçiniz</option>
          <option *ngFor="let item of provinces" [value]="item.id">
            {{item.name}}
          </option>
        </select>
      </div>

      <div class="col-md-4 col-sm-12">
        <label class="form-label" for="districtId">İlçe</label>
        <select class="form-control" formControlName="districtId">
          <option value="" disabled selected>İlçe Seçiniz</option>
          <option *ngFor="let item of districts" [value]="item.id">
            {{ item.name }}
          </option>
        </select>
        <div *ngIf="companyForm.get('districtId').hasError('required')">
          <small class="text-danger">İlçe seçmek zorunludur.</small>
        </div>
      </div>
    </div>
    <div class="ml-1 d-flex justify-content-end">
      <button type="submit" class="btn btn-success mr-1" rippleEffect [disabled]="companyForm.invalid">Kaydet</button>
      <button type="reset" class="btn btn-outline-secondary" rippleEffect (click)="closeModal()">İptal</button>
    </div>
  </form>
</div>